import React, { useState, useEffect, useContext,useRef } from 'react';
import MaterialTable from 'material-table';
import { useSelector, useDispatch } from "react-redux";
import CircularLoading from "../components/CircularLoading";
import { api, FirebaseContext } from 'common';
import PhotoSizeSelectSmallIcon from '@material-ui/icons/PhotoSizeSelectSmall';
import Modal from '@material-ui/core/Modal';
import { makeStyles } from '@material-ui/core/styles';
import FitnessCenterIcon from '@material-ui/icons/FitnessCenter';
import CancelScheduleSendIcon from '@material-ui/icons/CancelScheduleSend';
import { useTranslation } from "react-i18next";
import { Typography } from "@material-ui/core";
import { useNavigate } from 'react-router-dom';
import { Button, Grid, Tooltip, CircularProgress } from "@material-ui/core";
import CancelIcon from '@material-ui/icons/Cancel';
import AlertDialog from '../components/AlertDialog';
import { colors } from '../components/Theme/WebTheme';

const useStyles = makeStyles((theme) => ({
  modal: {
    display: 'flex',
    padding: theme.spacing(1),
    alignItems: 'center',
    justifyContent: 'center',
  },
  paper: {
    width: 780,
    backgroundColor: theme.palette.background.paper,
    border: '2px solid #000',
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
  },
}));

export default function CarTypes() {
  const { appcat } = useContext(FirebaseContext);
  const { t,i18n } = useTranslation();
  const navigate = useNavigate();
  // Restored from the deployed production bundle (main.b0f942f8): clicking a car
  // type's image opens this dialog, which is the only way to replace the image.
  const [selectedImage, setSelectedImage] = useState(null);
  const [imageData, setImageData] = useState(null);
  const [carTypeData, setCarTypeData] = useState();
  const [imageModal, setImageModal] = useState(false);
  const [imageLoading, setImageLoading] = useState(false);
  const [commonAlert, setCommonAlert] = useState({ open: false, msg: '' });

  const handleImageModal = () => {
    setImageModal(false);
    setSelectedImage(null);
  };

  const handleCommonAlertClose = (e) => {
    e.preventDefault();
    setCommonAlert({ open: false, msg: '' });
  };

  const onImageClick = (rowData) => {
    setImageData(rowData.image);
    setCarTypeData(rowData);
    setImageModal(true);
  };

  const handleSaveImage = (e) => {
    e.preventDefault();
    if (selectedImage) {
      setImageLoading(true);
      let finalData = carTypeData;
      finalData.image = selectedImage;
      dispatch(editCarType(finalData, 'UpdateImage'));
      setImageModal(false);
      setTimeout(() => {
        setSelectedImage(null);
        setImageLoading(false);
      }, 10000);
    } else {
      setCommonAlert({ open: true, msg: t('choose_image_first') });
    }
  };
  const isRTL = i18n.dir();
  const settings = useSelector(state => state.settingsdata.settings);
  const {
    editCarType
  } = api;
  const columns = [
    { title: t('name'), field: 'name', cellStyle:isRTL ==='rtl'? {paddingRight:appcat === 'taxi'? 100: 180 , textAlign: 'right' }:{ paddingLeft: appcat === 'taxi'? 100: 180}, headerStyle:isRTL==='rtl'?{paddingRight: appcat === 'taxi'? 100: 180}:{ paddingLeft: appcat === 'taxi'? 100: 180}},
    { title: t('image'), field: 'image', cellStyle:{ textAlign: 'center'},render: rowData => rowData.image ?
      <button onClick={() => { onImageClick(rowData); }}>
        <img alt='Car' src={rowData.image} style={{ width: 50 }}/>
      </button> : null},
    { title: t('base_fare'), field: 'base_fare', type: 'numeric', cellStyle:{ textAlign: 'center'}},
    { title: t('rate_per_unit_distance'), field: 'rate_per_unit_distance', type: 'numeric', cellStyle:{ textAlign: 'center'}},
    { title: t('rate_per_hour'), field: 'rate_per_hour', type: 'numeric', cellStyle:{ textAlign: 'center'}},
    { title: t('min_fare'), field: 'min_fare', type: 'numeric', cellStyle:{ textAlign: 'center'}},
    { title: t('convenience_fee'), field: 'convenience_fees', type: 'numeric', cellStyle:{ textAlign: 'center'}},
    {
      title: t('convenience_fee_type'),
      field: 'convenience_fee_type',
      lookup: { flat: t('flat'), percentage: t('percentage')},
      cellStyle:{ textAlign: 'center'}
    },
    { title: t('extra_info'), field: 'extra_info' , cellStyle:{ textAlign:isRTL ==='rtl'? 'right' : 'left'}}
  ];

  const subcolumns = [
    { title: t('description'), field: 'description', render: rowData => <span>{rowData.description}</span> },
    { title: t('amount'), field: 'amount', type: 'numeric' }
  ];

  const subcolumns2 = [
    { title: t('minsDelayed'), field: 'minsDelayed', render: rowData => <span>{rowData.minsDelayed}</span> },
    { title: t('amount'), field: 'amount', type: 'numeric' }
  ];

  const [data, setData] = useState([]);
  const cartypes = useSelector(state => state.cartypes);
  const dispatch = useDispatch();
  const rootRef = useRef(null);
  const classes = useStyles();
  const [open,setOpen] = useState(false);
  const [rowIndex,setRowIndex] = useState();
  const [modalType,setModalType] = useState();

  const handleClose = () => {
    setOpen(false);
  }

  useEffect(() => {
    if (cartypes.cars) {
      setData(cartypes.cars);
    } else {
      setData([]);
    }
  }, [cartypes.cars]);

  return (
    cartypes.loading ? <CircularLoading /> :
    <div ref={rootRef}>
      <MaterialTable
        title={t('car_type_title')}
        columns={columns}
        data={data}
        style={{direction:isRTL ==='rtl'?'rtl':'ltr'}}
        options={{
          exportButton: true,
        }}
        localization={{body:{
          addTooltip: (t('add')),
          deleteTooltip: (t('delete')),
          editTooltip: (t('edit')),
          emptyDataSourceMessage: (
            (t('blank_message'))
        ),
        editRow: { 
          deleteText: (t('delete_message')),
          cancelTooltip: (t('cancel')),
          saveTooltip: (t('save')) 
           }, 
          },
          toolbar: {
            searchPlaceholder: (t('search')),
            exportTitle: (t('export')),
          },
          header: {
            actions: (t('actions')) 
        },
        pagination: {
          labelDisplayedRows: ('{from}-{to} '+ (t('of'))+ ' {count}'),
          labelRowsSelect: (t('rows')),
          firstTooltip: (t('first_page_tooltip')),
          previousTooltip: (t('previous_page_tooltip')),
          nextTooltip: (t('next_page_tooltip')),
          lastTooltip: (t('last_page_tooltip'))
        },
        }}
        editable={{
          onRowAdd: newData =>
          settings.AllowCriticalEditsAdmin?
            new Promise(resolve => {
              setTimeout(() => {
                  newData['createdAt'] = new Date().toISOString();
                  dispatch(editCarType(newData,"Add"));
                  resolve();
              }, 600);
            })
            :
            new Promise(resolve => {
              setTimeout(() => {
                resolve();
                alert(t('demo_mode'));
              }, 600);
            }),
          onRowUpdate: (newData, oldData) =>
            settings.AllowCriticalEditsAdmin?
            new Promise(resolve => {
              setTimeout(() => {
                resolve();
                dispatch(editCarType(newData,"Update"));
              }, 600);
            })
            :
            new Promise(resolve => {
              setTimeout(() => {
                resolve();
                alert(t('demo_mode'));
              }, 600);
            }),
          onRowDelete: oldData =>
            settings.AllowCriticalEditsAdmin?
            new Promise(resolve => {
              setTimeout(() => {
                resolve();
                dispatch(editCarType(oldData,"Delete"));
              }, 600);
            })
            :
            new Promise(resolve => {
              setTimeout(() => {
                resolve();
                alert(t('demo_mode'));
              }, 600);
            })
        }}
        actions={[
          rowData => (appcat === 'delivery'?{
            icon: () => <div style={{display: 'flex',alignItems: 'center',flexWrap: 'wrap'}}>
                <PhotoSizeSelectSmallIcon />
                <Typography variant="subtitle2" style={{padding: 5}}>{t('parcel_types')}</Typography>
            </div>,
            onClick: (event, rowData) => {
              setModalType('parcelTypes')
              setRowIndex(rowData.tableData.id);
              setOpen(true);
            }
          }:null),
          rowData => (appcat === 'delivery'?{
            icon: () => <div style={{display: 'flex',alignItems: 'center',flexWrap: 'wrap'}}>
                <FitnessCenterIcon />
                <Typography variant="subtitle2" style={{padding: 5}}>{t('options')}</Typography>
            </div>,
            onClick: (event, rowData) => {
              setModalType('options')
              setRowIndex(rowData.tableData.id);
              setOpen(true);
            }
          }:null),
          rowData => ({
            icon: () => <div style={{display: 'flex',alignItems: 'center',flexWrap: 'wrap'}}>
                <CancelScheduleSendIcon />
                <Typography variant="subtitle2" style={{padding: 5}}>{t('cancelSlab')}</Typography>
            </div>,
            onClick: (event, rowData) => {
              setModalType('cancelSlab')
              setRowIndex(rowData.tableData.id);
              setOpen(true);
            }
          }),
          // Restored from the deployed production bundle (main.b0f942f8). Without
          // these two the /cartypes/addcartype and /cartypes/updatecartypes/:id
          // routes are unreachable, so there is no way to change a car type's image.
          {
            icon: 'add',
            tooltip: t('add_carType'),
            isFreeAction: true,
            onClick: () => navigate('/cartypes/addcartype')
          },
          {
            icon: 'edit',
            tooltip: t('edit'),
            onClick: (event, rowData) => navigate(`/cartypes/updatecartypes/${rowData.id}`)
          }
        ]}
      />
      <Modal
        disablePortal
        disableEnforceFocus
        disableAutoFocus
        onClose={handleClose}
        open={open}
        className={classes.modal}
        container={() => rootRef.current}
      >
        <div className={classes.paper}>
          <MaterialTable
            title={modalType === 'options'?t('options') :( modalType === 'cancelSlab' ? t('cancelSlab'): t('parcel_types'))}
            columns={modalType === 'cancelSlab'? subcolumns2 :subcolumns }
            data={(data[rowIndex] && data[rowIndex][modalType])?data[rowIndex][modalType]:[]}
            options={{
              exportButton: true,
            }}
            editable={{
              onRowAdd: newData =>
                settings.AllowCriticalEditsAdmin?
                new Promise((resolve) => {
                  setTimeout(() => {
                    resolve();
                    let tblData = data;
                    if(!tblData[rowIndex][modalType]){
                      tblData[rowIndex][modalType] = [];
                    }
                    tblData[rowIndex][modalType].push(newData);
                    dispatch(editCarType(tblData[rowIndex]), "Update");
                  }, 600);
                })
                :
                new Promise(resolve => {
                  setTimeout(() => {
                    resolve();
                    alert(t('demo_mode'));
                  }, 600);
                }),
              onRowUpdate: (newData, oldData) =>
                settings.AllowCriticalEditsAdmin?
                new Promise((resolve) => {
                  setTimeout(() => {
                    resolve();
                    let tblData = data;
                    tblData[rowIndex][modalType][tblData[rowIndex][modalType].indexOf(oldData)] = newData;
                    dispatch(editCarType(tblData[rowIndex]), "Update");
                  }, 600);
                })
                :
                new Promise(resolve => {
                  setTimeout(() => {
                    resolve();
                    alert(t('demo_mode'));
                  }, 600);
                }),
              onRowDelete: oldData =>
                settings.AllowCriticalEditsAdmin?
                new Promise((resolve) => {
                  setTimeout(() => {
                    resolve();
                    let tblData = data;
                    tblData[rowIndex][modalType].splice(tblData[rowIndex][modalType].indexOf(oldData), 1);
                    dispatch(editCarType(tblData[rowIndex]), "Update");
                  }, 600);
                })
                :
                new Promise(resolve => {
                  setTimeout(() => {
                    resolve();
                    alert(t('demo_mode'));
                  }, 600);
                }),
            }}  
          />
        </div>
      </Modal>
      <Modal
        disablePortal
        disableEnforceFocus
        disableAutoFocus
        open={imageModal}
        onClose={handleImageModal}
        className={classes.modal}
        container={() => rootRef.current}
      >
        <Grid container spacing={1} className={classes.paper} style={{ direction: isRTL === 'rtl' ? 'rtl' : 'ltr' }}>
          <Grid item xs={12}>
            <Typography component="h1" variant="h6">
              {t('image')}
              <input
                type="file"
                style={{ marginLeft: 10 }}
                name={t('image')}
                onChange={(event) => { setSelectedImage(event.target.files[0]); }}
              />
            </Typography>
          </Grid>
          <Grid item xs={12}>
            {selectedImage && !imageLoading ?
              <Tooltip title={t('cancel')}>
                <CancelIcon
                  onClick={() => setSelectedImage(null)}
                  style={{ fontSize: 30, backgroundColor: 'red', borderRadius: 50, color: 'white' }}
                />
              </Tooltip> : null}
          </Grid>
          <Grid item xs={12}>
            <img
              alt="CarType"
              width={'200px'}
              height={'200px'}
              src={selectedImage ? URL.createObjectURL(selectedImage) : imageData}
              style={{ marginTop: 10, marginBottom: 20 }}
            />
            <br />
          </Grid>
          <Grid item xs={12} style={{ textAlign: isRTL === 'rtl' ? 'right' : 'left' }}>
            {imageLoading ?
              <Grid container spacing={0} alignItems="center" justify="center" style={{ minHeight: '5vh' }}>
                <CircularProgress />
              </Grid>
              :
              <Grid item xs={12} style={{ textAlign: isRTL === 'rtl' ? 'right' : 'left' }}>
                <Button onClick={handleImageModal} variant="contained" style={{ backgroundColor: colors.RED }}>
                  {t('cancel')}
                </Button>
                <Button onClick={handleSaveImage} variant="contained" style={{ marginLeft: 10, backgroundColor: colors.GREEN }}>
                  {t('save')}
                </Button>
              </Grid>}
          </Grid>
        </Grid>
      </Modal>
      <AlertDialog open={commonAlert.open} onClose={handleCommonAlertClose}>
        {commonAlert.msg}
      </AlertDialog>
    </div>
  );
}
